import { useState } from "react";
import { apiFetch } from "./services/apiClient";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Store.css";
import logo from "./fivlialogo.png";

function StoreLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

 const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const res = await apiFetch("/storeLogin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password
      }),
    });

    const data = await res.json();

    if (res.status === 200 && data.storeId) {
      alert("Login successful");

      localStorage.removeItem("loginSource"); // NEW: direct store login is never an admin session
      localStorage.setItem("userType", "store");
      localStorage.setItem("storeId", data.storeId);
      if (data.token) localStorage.setItem("token", data.token);

      window.location.href = "/dashboard1";
    } else {
      alert(data.message || "Invalid credentials");
    }
  } catch (err) {
    console.error("Login Error:", err);
    alert("Server error. Try again later.");
  }
};


  return (
    <div className="login-background">
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <img
            src={logo}
            style={{
              width: "130px",
              display: "flex",
              justifyContent: "center",
              alignSelf: "center",
            }}
            alt="Fivlia"
          />
          <h2>Login</h2>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="password-wrapper">
            <input
              style={{ width: "343px" }}
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default StoreLogin;
